import { clearObj, formatDatesInPayload } from '@marfa/bo-utils';
import { ApiResourceMethod } from '@/api/api-requests-factory';
import { ReportListCsvRequestModel } from '@/models/report/report.model';
import { FileDataResponse } from '@/models/app-internal/file-data-response.model';
import { ReportListFilterFields } from '@/models/report/report-list-filter.model';

export class GetReportListCsvRequest extends ApiResourceMethod<FileDataResponse> {
  public perform(params: ReportListCsvRequestModel): Promise<FileDataResponse> {
    const requestData: ReportListCsvRequestModel = { ...params };
    const { filterList, ...restParams } = requestData;

    const requestParams = filterList && Object.keys(filterList).length > 0
      ? {
          ...restParams,
          ...formatDatesInPayload({
            payload: { ...filterList },
            isUnixToString: false,
            isIncludeTime: true,
          }, [
            ReportListFilterFields.DATE_FROM,
            ReportListFilterFields.DATE_TO,
            ReportListFilterFields.EXCHANGE_RATE_DATE,
          ]),
        }
      : restParams;

    return this.performer.request(
      {
        params: clearObj(requestParams),
      },
    );
  }
}
